import { render, staticRenderFns } from "./moduleStructure.vue?vue&type=template&id=a6de1692"
import script from "./moduleStructure.vue?vue&type=script&lang=js"
export * from "./moduleStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports